import { StoreManager } from './store.manager';

// The single app-wide store, in its own module so lazy helpers (e.g. enable.rtk.ts) can import `storeManager`
// without an index <-> helper import cycle. Imports only the StoreManager class — no RTK — so it stays eager-safe.
export const storeManager = new StoreManager();
export const store = storeManager.store;
export const dispatch = store.dispatch.bind(store);
